import {
  SCOUT_SERVICE_JOBS_FILTER_TYPE,
  SCOUT_SERVICE_JOBS_SORT_TYPE,
} from '@doda/common/src/constants/scoutServiceJob';
import { Bookmark } from '@doda/common/src/interfaces/api/scoutServiceJobs';
import { getBookmarkList } from '@doda/common/src/services/getBookmarkListAPI';
import {
  MAX_COUNT,
  NaviItem,
} from 'components/FollowSearchResultsNavigation/constants';
import { useState } from 'react';

interface ArgumentType {
  isOpenMenu: boolean;
  menuContents: number | null;
  onClickMenuOpen: (item: NaviItem) => void;
}

/**
 * 気になるリスト
 * @param param.isOpenMenu アコーディオンメニューが開いているかの判定フラグ
 * @param param.menuContents 表示するアコーディオンメニューの内容
 * @param param.onClickMenuOpen アコーディオンメニュー開閉のイベント処理
 * @returns 気になるリストデータとメニュー表示時のイベント処理
 */
export const useBookmarkList = ({
  isOpenMenu,
  menuContents,
  onClickMenuOpen,
}: ArgumentType) => {
  const [bookmarkList, setBookmarkList] = useState<Bookmark[]>([]);
  const onClickBookmarkList = async (item: NaviItem) => {
    // 気になるリストのメニューを開いている状態で気になるリストを押下した際、メニューを閉じて早期リターン
    if (isOpenMenu && item.id === menuContents) {
      onClickMenuOpen(item);
      return;
    }
    try {
      const { bkmList } = await getBookmarkList({
        pageNumber: 1,
        filterId: SCOUT_SERVICE_JOBS_FILTER_TYPE.DEFAULT,
        sortId: SCOUT_SERVICE_JOBS_SORT_TYPE.NEW_SAVE_DATA,
      });
      // 気になる登録が０件の時、メニューだけ開いて早期リターン
      if (!bkmList) {
        onClickMenuOpen(item);
        return;
      }
      // 最大10件を抽出
      const targetBkmList = bkmList.slice(0, MAX_COUNT);
      setBookmarkList(targetBkmList);
      onClickMenuOpen(item);
    } catch {
      window.DD_LOGS?.logger.error({
        message: `気になるスカウトサービス求人取得の失敗`,
      });
    }
  };
  return {
    bookmarkList,
    onClickBookmarkList,
  };
};
